<template>
  <div class="telegram">
    <Modal :modal="modal" />
  </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import { mapGetters } from "vuex";
export default {
  name: "Telegram",
  components: {
    Modal
  },
  data() {
    return {
      modal: {
        layout: "Telegram",
        show: false
      }
    };
  },
  computed: {
    ...mapGetters("user", ["user"])
  },
  mounted(){
      if(this.user.autoriza_telegram==null && this.user.perfil!='agregado_doutor') this.modal.show = true
  }
};
</script>